const state= {
    DOLog: {
        data:[],
        total : 0,
    }
};

const getters = {
    DOLog : (state) => state.DOLog
};

const actions = {
    async getDOLog({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`/api/do-line-items`, {params:params})
            .then(response => {
                response.data.data.pages = params
                commit('setDOLogItems', response.data.data);
                resolve(response)
            })
            .catch(error => reject( error ));
        });
    },
    async createDOLog({commit}, params){
        return new Promise (( resolve, reject ) => {

            let formData = new FormData();
            for( var i = 0; i < params.attachments.length; i++ ){
                let photo = params.attachments[i];
                formData.append('photos[' + i + ']', photo);
                formData.append('fileTitles[' + i + ']', photo.image_file_title || '');
            }
            formData.append("do_number", params.do_number );
            formData.append("order_id", params.order_id );
            formData.append("log_time", params.log_time );
            formData.append("do_ref_number", params.do_ref_number );
            formData.append("contract_id", params.contract_id );
            formData.append("line_items", JSON.stringify(params.line_items));
            global.axios.post("/api/do-line-items",formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    resolve(response.data.data)
                })
                .catch(error => reject( error ));

        });
    },
    async updateDOLog({commit}, params){
        return new Promise (( resolve, reject ) => {
            let formData = new FormData();
            for( var i = 0; i < params.attachments.length; i++ ){
                let photo = params.attachments[i];
                formData.append('photos[' + i + ']', photo);
                formData.append('fileTitles[' + i + ']', photo.image_file_title || '');
            }
            for( var i = 0; i < params.attachmentUpdate.length; i++ ){
                let photo = params.attachmentUpdate[i];
                formData.append('photosUpdate[' + photo.id + ']', photo.attachment || '');
                formData.append('fileTitlesUpdate[' + photo.id + ']', photo.image_file_title || '');
            }
            for( var j = 0; j < params.attachmentsDelete.length; j++ ){
                let photoD = params.attachmentsDelete[j];
                formData.append('photosDelete[' + j + ']', photoD.id);
            }
            formData.append("do_id", params.do_id );
            formData.append("log_time", params.log_time || '' );
            formData.append("delivered_quantity", params.delivered_quantity || '' );
            formData.append("do_ref_number", params.do_ref_number || '');

            global.axios.post(`/api/do-line-items/${params.id}`, formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                resolve(response.data.data)
            })
            .catch(error => reject( error ));
        });
    },
    async deleteDOLog({commit}, ids){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`/api/do-line-items`, {
                data:{
                    ids:ids
                }
          })
            .then(response => {
                resolve(response.data.data)
            })
            .catch(error => reject( error ));
        });
    },
};

const mutations = {
    setDOLogItems (state,data) {
        state.DOLog.data = data.items;
        state.DOLog.total = data.total;
    },
    
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}